import cx from "classnames";
import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

import CS from "metabase/css/core/index.css";
import { Flex, type FlexProps, Text, type TextProps } from "metabase/ui";

import S from "./ViewSection.module.css";

export type ViewSectionProps = FlexProps & {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
};

export const ViewSection = ({
  className,
  style,
  children,
  ...rest
}: ViewSectionProps) => (
  <Flex className={cx(S.ViewSectionRoot, className)} style={style} {...rest}>
    {children}
  </Flex>
);

type ViewHeadingProps = TextProps & {
  children?: ReactNode;
  level?: 1 | 2;
};

export const ViewHeading = ({
  children,
  level = 1,
  ...props
}: ViewHeadingProps) => (
  <Text
    component={level === 1 ? "h1" : "h2"}
    lh="normal"
    c="text-primary"
    fz="18px"
    fw={700}
    {...props}
  >
    {children}
  </Text>
);

interface ViewSubHeadingProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const ViewSubHeading = ({ children, ...props }: ViewSubHeadingProps) => (
  <div className={cx(CS.textMedium, CS.textBold)} {...props}>
    {children}
  </div>
);
